import { useEffect, useState } from 'react';
import { ArrowUpDown } from 'lucide-react';
import { SORTS, getSort, setSort } from './ticketDate';

export const useTicketSort = () => {
  const [mode, setMode] = useState(getSort());
  useEffect(() => {
    const on = () => setMode(getSort());
    window.addEventListener('ticket-sort-changed', on);
    return () => window.removeEventListener('ticket-sort-changed', on);
  }, []);
  return mode;
};

// Sort bar over every ticket view; the choice is remembered on this device.
export const SortBar = () => {
  const mode = useTicketSort();
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-0.5" data-testid="ticket-sort-bar">
      <ArrowUpDown className="h-3.5 w-3.5 shrink-0 text-zinc-500" />
      {SORTS.map(([k, label]) => (
        <button key={k} type="button" onClick={() => setSort(k)} data-testid={`ticket-sort-${k}`}
          className={`shrink-0 rounded-full px-3 py-1 text-xs font-bold transition-colors ${mode === k ? 'bg-amber-500 text-black' : 'border border-zinc-700 text-zinc-300 hover:text-white'}`}>
          {label}
        </button>
      ))}
    </div>
  );
};
